<template>
  <div v-loading="loading">
    <!-- 日期范围 -->
    <div
      style="margin-bottom: 10px; padding: 20px; border: 1px solid lightgray"
    >
      日期范围：
      <el-date-picker
        :picker-options="pickerDate"
        size="mini"
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
    </div>
    <!-- 价格与库存 -->
    <el-form
      :inline="true"
      :model="addStockPrice"
      v-for="(item, index) in show_sku_price"
      :key="index"
    >
      <div class="add-price-stock-title">
        套餐名称:{{ item.sku_name }}
        <el-button
          @click="addPriceType(item.sku_id)"
          type="text"
          style="float: right"
          size="mini"
          >添加规格</el-button
        >
      </div>
      <!-- 类型 -->
      <div v-for="(type_item, index) in item.price_items" :key="index">
        <el-form-item style="margin-bottom: 0px">
          <el-autocomplete
            :fetch-suggestions="querySearch"
            @select="handleSelect($event, type_item)"
            style="width: 200px"
            size="mini"
            v-model.trim="type_item.price_type_name"
          >
            <template slot="prepend">规格</template>
          </el-autocomplete>
        </el-form-item>
        <!-- 类型说明 -->
        <el-form-item style="margin-bottom: 0px">
          <el-input
            style="width: 250px"
            size="mini"
            v-model="type_item.price_type_info"
          >
            <template slot="prepend">规格说明</template>
          </el-input>
        </el-form-item>
        <!-- 价格 -->
        <el-form-item style="margin-bottom: 0px">
          <el-input
            style="width: 200px"
            size="mini"
            v-model.number="type_item.price"
          >
            <template slot="prepend">售价</template>
          </el-input>
        </el-form-item>
        <!-- 底价 -->
        <el-form-item style="margin-bottom: 0px">
          <el-input
            style="width: 200px"
            size="mini"
            v-model.number="type_item.net_price"
            @input="handleInput($event, type_item)"
          >
            <template slot="prepend">底价</template>
          </el-input>
        </el-form-item>
        <!-- 库存 -->
        <el-form-item style="margin-bottom: 0px">
          <el-input style="width: 150px" size="mini" v-model="type_item.stock">
            <template slot="prepend">可订量</template>
          </el-input>
        </el-form-item>
      </div>
    </el-form>

    <!-- 按钮 -->
    <el-divider></el-divider>
    <div class="confirm_button_product_price_change">
      <el-button size="mini" @click="cancelAddStockPrice">取 消</el-button>
      <el-button size="mini" type="primary" @click="confrimAddStockPrice"
        >提 交</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "price-of-product",
  data() {
    return {
      loading: this.loading_up_price,
      pickerDate: {
        // disabledDate:设置禁用状态，参数为当前日期，要求返回 Boolean
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      dateRange: "", // 日期选择的结果
      addStockPrice: {}, // 表单对象，存放库存价格等信息
      show_sku_price: [], //sku 价格列表（后台返回数据）
    };
  },
  props: {
    spu_id: Number,
    loading_up_price: false,
  },
  watch: {
    loading_up_price: {
      immediate: true,
      handler(value) {
        this.loading = value;
      },
    },
  },
  created() {
    this.getProductPrice(this.spu_id);
  },
  methods: {
    // 获取产品价格信息
    getProductPrice(spu_id) {
      // 批量改价 【对话框】
      console.log("get product price info");
      if (this.skus == "") {
        this.$message({
          message: "目前没有套餐，请先添加套餐",
          type: "warning",
        });
      } else {
        this.$http
          .get(`/product/get_base_price_info?spu_id=${spu_id}`)
          .then((res) => {
            // console.log(res);
            this.show_sku_price = res.data.data;
          });
        this.dialogAddStockPriceProp = true;
      }
    },
    // 输入数字自动保留2位小数

    handleInput(value, item) {
      if (value != "") {
        if (value.indexOf(".") > -1) {
          console.log(value);
          //   item.net_price = value.slice(0, value.indexOf(".") + 3);
        } else {
          console.log(value);
          //   item.net_price = value;
        }
      }
    },
    addPriceType(sku) {
      // 添加 套餐规格 de 按钮
      //console.log(this.show_sku_price);
      for (let item of this.show_sku_price) {
        if (item.sku_id == sku) {
          item.price_items.push({
            net_price: 0,
            price: 0,
            price_type_info: "",
            price_type: "",
            price_type_name: "",
            stock: "",
          });
        }
      }
    },
    // 输入框自动匹配
    querySearch(queryString, cb) {
      this.$http.get("/get_price_type").then((res) => {
        if (res.data.errno == "4002") {
          this.$notify({
            title: "错误",
            message: res.data.errmsg,
            type: "warning",
          });
        } else if (res.data.errno == "0") {
          var price_type_list = res.data.data;
          var results = queryString
            ? price_type_list.filter(this.createFilter(queryString))
            : price_type_list;
          // 调用 callback 返回建议列表的数据
          cb(results);
        }
      });
    },
    createFilter(queryString) {
      // 做匹配用的：1 把输入的子都变成小写。2 全部小写后 通过indexof 取字符串的第一个字
      // indexOf() 返回某个指定的字符串值在字符串中首次出现的位置。
      // toLowerCase() 方法用于把字符串转换为小写
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect(value, x) {
      // 从筛选结果中选择时
      x.price_type = value.id;
      // console.log(item.price_items.price_type);
    },
    cancelAddStockPrice() {
      //  取消添加
      this.$emit("closeDealWithOk", false);
    },
    confrimAddStockPrice() {
      console.log(this.show_sku_price);
      //  确认添加 【规格价格】
      new Promise((resolve, reject) => {
        this.loading = true;
        // 将价格处理一下
        this.show_sku_price.forEach((i) => {
          i.price_items.forEach((item) => {
            item.net_price = item.net_price * 100;
            item.price = item.price * 100;
          });
        });
        resolve();
      }).then(() => {
        let updateItems = {
          date_range: this.dateRange,
          spu_id: this.spu_id,
          out_spu_id: this.out_spu_id,
          sku_price_items: this.show_sku_price,
        };
        // 保存 新的 规格 类型
        const sku_items = this.show_sku_price;
        this.$http.post("/product/get_stock_type", sku_items).then((res) => {
          console.log(res);
          res.data.data;
        });

        // 保存 日历库存
        this.$http.post("/product/sku/update", updateItems).then((res) => {
          // console.log(res);
          const { errmsg, errno } = res.data;
          if (errno == "0") {
            this.$notify({
              title: "成功",
              message: errmsg,
              type: "success",
            });
            // 关闭loagding
            this.loading = false;
            // 关闭对话框
            this.$emit("closeDealWithOk", false);
          } else if (errno == "4004") {
            this.$notify({
              title: "警告",
              message: errmsg,
              type: "warning",
            });
            // 关闭loagding
            this.loading = false;
          }
        });
      });
    },
  },
};
</script>

<style>
.confirm_button_product_price_change {
  margin-top: 20px;
  text-align: center;
}
</style>